export default __webpack_public_path__ + "static/media/Florije-Manaj-Zogaj.26d8d3b2.jpg";